// src\themes\mad\elements\Header\HeaderWrapper.tsx
'use client';

import { useEffect, useState } from 'react';
import clsx from 'clsx';

export default function HeaderWrapper({
    children,
}: {
    children: React.ReactNode;
}) {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        handleScroll(); // برای refresh وسط صفحه
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div
            className={clsx(
                'fixed top-0 left-0 w-full z-50 transition-all duration-300',
                scrolled
                    ? 'bg-primary-0 text-primary-900 shadow-md'
                    : 'bg-transparent text-primary-0'
            )}
        >
            {children}
        </div>
    );
}
